import useGameEventEffects from './useGameEventEffects';
import useGameRedirect from './useGameRedirect';

const useGame = () => {
  useGameEventEffects();
  const { redirectTo } = useGameRedirect();
  return { isGameBlocked: Boolean(redirectTo) };
};

export default useGame;
